export type FaixaTempoPedido = 'verde' | 'amarelo' | 'vermelho' | 'neutro';

export function faixaTempoPedido(dataCadastro: string, agoraMs: number): FaixaTempoPedido {
  const inicioMs = new Date(dataCadastro).getTime();
  if (!Number.isFinite(inicioMs)) return 'neutro';

  const tempoMs = Math.max(0, agoraMs - inicioMs);
  if (tempoMs <= 30 * 60 * 1000) return 'verde';
  if (tempoMs < 60 * 60 * 1000) return 'amarelo';
  return 'vermelho';
}
